<template>
    <li class="finder__card impairment__card" :class="cardClass">
        <a
            v-if="impairment.card_url"
            :href="impairment.card_url"
            class="finder__card-link"
        >
            <span class="finder__card-title step--3">{{ impairment.title }}</span>

            <p v-if="subTitles.length" class="finder__card-subs">
                {{ subLine }}
            </p>

            <p
                v-if="footnote && eligible"
                class="finder__footnote"
                v-html="footnote"
            ></p>

            <p class="finder__eligibility" :class="eligibilityClass">
                <span
                    v-if="eligible"
                    class="finder__eligibility-icon"
                    aria-hidden="true"
                    v-html="icoCheck"
                ></span>
                {{ eligibilityLabel }}
            </p>

            <span class="screen-reader-text">{{ screenReaderSuffix }}</span>
        </a>

        <template v-else>
            <span class="finder__card-title step--3">{{ impairment.title }}</span>

            <p v-if="subTitles.length" class="finder__card-subs">
                {{ subLine }}
            </p>

            <p
                v-if="footnote && eligible"
                class="finder__footnote"
                v-html="footnote"
            ></p>

            <p class="finder__eligibility" :class="eligibilityClass">
                <span
                    v-if="eligible"
                    class="finder__eligibility-icon"
                    aria-hidden="true"
                    v-html="icoCheck"
                ></span>
                {{ eligibilityLabel }}
            </p>

            <span class="screen-reader-text">{{ screenReaderSuffix }}</span>
        </template>
    </li>
</template>

<script>
export default {
    props: {
        impairment: {
            type: Object,
            required: true,
        },
        eligible: {
            type: Boolean,
            default: true,
        },
        facetTitle: {
            type: String,
            default: '',
        },
        footnote: {
            type: String,
            default: '',
        },
        subTitles: {
            type: Array,
            default: () => [],
        },
        appliesToLabel: {
            type: String,
            default: '',
        },
        forLabel: {
            type: String,
            default: '',
        },
        eligibleLabel: {
            type: String,
            default: '',
        },
        notEligibleLabel: {
            type: String,
            default: '',
        },
        icoCheck: {
            type: String,
            default: '',
        },
    },
    computed: {
        cardClass() {
            return this.eligible ? 'finder__card--eligible' : 'finder__card--not-eligible';
        },
        eligibilityClass() {
            return this.eligible ? '' : 'finder__eligibility--not';
        },
        eligibilityLabel() {
            return this.eligible ? this.eligibleLabel : this.notEligibleLabel;
        },
        subLine() {
            return `${ this.appliesToLabel }: ${ this.subTitles.join( ', ' ) }`;
        },
        screenReaderSuffix() {
            return `${ this.impairment.title } ${ this.forLabel } ${ this.facetTitle }`;
        },
    },
};
</script>
